import superagent from '@ott/superagent';

export const sendStatisticsRequest = async (url: string): Promise<void> => {
  await superagent.post(url);
};

export default sendStatisticsRequest;
